function _array_like_to_array(arr, len) {
    if (len == null || len > arr.length) len = arr.length;
    for(var i = 0, arr2 = new Array(len); i < len; i++)arr2[i] = arr[i];
    return arr2;
}
function _array_with_holes(arr) {
    if (Array.isArray(arr)) return arr;
}
function asyncGeneratorStep(gen, resolve, reject, _next, _throw, key, arg) {
    try {
        var info = gen[key](arg);
        var value = info.value;
    } catch (error) {
        reject(error);
        return;
    }
    if (info.done) {
        resolve(value);
    } else {
        Promise.resolve(value).then(_next, _throw);
    }
}
function _async_to_generator(fn) {
    return function() {
        var self = this, args = arguments;
        return new Promise(function(resolve, reject) {
            var gen = fn.apply(self, args);
            function _next(value) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "next", value);
            }
            function _throw(err) {
                asyncGeneratorStep(gen, resolve, reject, _next, _throw, "throw", err);
            }
            _next(undefined);
        });
    };
}
function _define_property(obj, key, value) {
    if (key in obj) {
        Object.defineProperty(obj, key, {
            value: value,
            enumerable: true,
            configurable: true,
            writable: true
        });
    } else {
        obj[key] = value;
    }
    return obj;
}
function _iterable_to_array_limit(arr, i) {
    var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"];
    if (_i == null) return;
    var _arr = [];
    var _n = true;
    var _d = false;
    var _s, _e;
    try {
        for(_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true){
            _arr.push(_s.value);
            if (i && _arr.length === i) break;
        }
    } catch (err) {
        _d = true;
        _e = err;
    } finally{
        try {
            if (!_n && _i["return"] != null) _i["return"]();
        } finally{
            if (_d) throw _e;
        }
    }
    return _arr;
}
function _non_iterable_rest() {
    throw new TypeError("Invalid attempt to destructure non-iterable instance.\\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
}
function _object_spread(target) {
    for(var i = 1; i < arguments.length; i++){
        var source = arguments[i] != null ? arguments[i] : {};
        var ownKeys = Object.keys(source);
        if (typeof Object.getOwnPropertySymbols === "function") {
            ownKeys = ownKeys.concat(Object.getOwnPropertySymbols(source).filter(function(sym) {
                return Object.getOwnPropertyDescriptor(source, sym).enumerable;
            }));
        }
        ownKeys.forEach(function(key) {
            _define_property(target, key, source[key]);
        });
    }
    return target;
}
function ownKeys(object, enumerableOnly) {
    var keys = Object.keys(object);
    if (Object.getOwnPropertySymbols) {
        var symbols = Object.getOwnPropertySymbols(object);
        if (enumerableOnly) {
            symbols = symbols.filter(function(sym) {
                return Object.getOwnPropertyDescriptor(object, sym).enumerable;
            });
        }
        keys.push.apply(keys, symbols);
    }
    return keys;
}
function _object_spread_props(target, source) {
    source = source != null ? source : {};
    if (Object.getOwnPropertyDescriptors) {
        Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
        ownKeys(Object(source)).forEach(function(key) {
            Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
        });
    }
    return target;
}
function _sliced_to_array(arr, i) {
    return _array_with_holes(arr) || _iterable_to_array_limit(arr, i) || _unsupported_iterable_to_array(arr, i) || _non_iterable_rest();
}
function _unsupported_iterable_to_array(o, minLen) {
    if (!o) return;
    if (typeof o === "string") return _array_like_to_array(o, minLen);
    var n = Object.prototype.toString.call(o).slice(8, -1);
    if (n === "Object" && o.constructor) n = o.constructor.name;
    if (n === "Map" || n === "Set") return Array.from(n);
    if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _array_like_to_array(o, minLen);
}
function _ts_generator(thisArg, body) {
    var f, y, t, g, _ = {
        label: 0,
        sent: function() {
            if (t[0] & 1) throw t[1];
            return t[1];
        },
        trys: [],
        ops: []
    };
    return g = {
        next: verb(0),
        "throw": verb(1),
        "return": verb(2)
    }, typeof Symbol === "function" && (g[Symbol.iterator] = function() {
        return this;
    }), g;
    function verb(n) {
        return function(v) {
            return step([
                n,
                v
            ]);
        };
    }
    function step(op) {
        if (f) throw new TypeError("Generator is already executing.");
        while(_)try {
            if (f = 1, y && (t = op[0] & 2 ? y["return"] : op[0] ? y["throw"] || ((t = y["return"]) && t.call(y), 0) : y.next) && !(t = t.call(y, op[1])).done) return t;
            if (y = 0, t) op = [
                op[0] & 2,
                t.value
            ];
            switch(op[0]){
                case 0:
                case 1:
                    t = op;
                    break;
                case 4:
                    _.label++;
                    return {
                        value: op[1],
                        done: false
                    };
                case 5:
                    _.label++;
                    y = op[1];
                    op = [
                        0
                    ];
                    continue;
                case 7:
                    op = _.ops.pop();
                    _.trys.pop();
                    continue;
                default:
                    if (!(t = _.trys, t = t.length > 0 && t[t.length - 1]) && (op[0] === 6 || op[0] === 2)) {
                        _ = 0;
                        continue;
                    }
                    if (op[0] === 3 && (!t || op[1] > t[0] && op[1] < t[3])) {
                        _.label = op[1];
                        break;
                    }
                    if (op[0] === 6 && _.label < t[1]) {
                        _.label = t[1];
                        t = op;
                        break;
                    }
                    if (t && _.label < t[2]) {
                        _.label = t[2];
                        _.ops.push(op);
                        break;
                    }
                    if (t[2]) _.ops.pop();
                    _.trys.pop();
                    continue;
            }
            op = body.call(thisArg, _);
        } catch (e) {
            op = [
                6,
                e
            ];
            y = 0;
        } finally{
            f = t = 0;
        }
        if (op[0] & 5) throw op[1];
        return {
            value: op[0] ? op[1] : void 0,
            done: true
        };
    }
}
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useMutation } from "@apollo/client";
import { useContext, useRef } from "react";
import * as z from "zod";
import { graphql } from "@oui/lib/src/graphql/tada";
import { OnboardingVariant, ProductVariant, ProductVersion, TestPatientInputSchema } from "@oui/lib/src/types/graphql.generated";
import { AuthScreenContainer } from "../components/AuthScreenContainer";
import { Button } from "../components/Button";
import { ErrorPresenter } from "../components/ErrorPresenter";
import { Label, Text } from "../components/Text";
import { View } from "../components/View";
import { APP_SLUG } from "../constants";
import { Controller, EmailInputRender, PickerInputRender, SwitchInputRender, TextInputRender, useZodForm } from "../form";
import { LogoutContext } from "../hooks/useLogout";
import { authClient } from "../lib/auth";
export var CreateTestUserMutation = graphql("\n  mutation CreateTestUser($email: String!, $password: String!, $testPatient: TestPatientInput!) {\n    createTestUser(email: $email, password: $password, testPatient: $testPatient)\n  }\n");
var CreateTestUserMutationSchema = z.object({
    email: z.string(),
    password: z.string(),
    testPatient: TestPatientInputSchema
});
var DEFAULT_TEST_PATIENT = {
    otx207: {
        productSlug: 'AVIVA_ADOLESCENT',
        roleType: 'PATIENT',
        onboardingVariant: OnboardingVariant.INDEPENDENT,
        caringContactsMedium: null
    },
    'aviva-support': {
        productSlug: 'AVIVA_ADOLESCENT',
        roleType: 'SUPPORTER'
    },
    'oui-aviva': {
        productSlug: 'AVIVA_ADULT',
        roleType: 'PATIENT',
        onboardingVariant: OnboardingVariant.INDEPENDENT,
        caringContactsMedium: null
    },
    'oui-aviva-staff': {},
    changebite: {
        productSlug: 'CHANGE_BITE',
        roleType: 'PATIENT'
    },
    yst: {},
    ptsd: {
        productSlug: 'PTSD',
        roleType: 'PATIENT'
    },
    DETOX_TEST: {}
}[APP_SLUG];
/**
 * Allows creation of new users intended for product testing purposes so that
 * accounts do not have to be provisioned through the platform website.
 *
 * Only intended to be accessible via the `DevMenu` rather than via a
 * "publicly" visisble navigation link.
 * @see {@link https://ouihealth.atlassian.net/browse/APPCORE-177}
 */ export function CreateTestUser() {
    var setIsLoggingOut = useContext(LogoutContext).setIsLoggingOut;
    var _useMutation = _sliced_to_array(useMutation(CreateTestUserMutation), 2), createTestUser = _useMutation[0], _useMutation_ = _useMutation[1], error = _useMutation_.error, loading = _useMutation_.loading;
    var _useZodForm = useZodForm(CreateTestUserMutationSchema.merge(z.object({
        email: z.string().email(),
        password: z.string().min(8, 'Must be at least 8 characters')
    })), {
        defaultValues: {
            password: '',
            email: '',
            testPatient: _object_spread({
                productVersion: ProductVersion.AVIVA_2_0,
                productStatic: false
            }, DEFAULT_TEST_PATIENT)
        }
    }), control = _useZodForm.control, handleSubmit = _useZodForm.handleSubmit;
    var emailInputRef = useRef(null);
    var passwordInputRef = useRef(null);
    var request = handleSubmit(/*#__PURE__*/ function() {
        var _ref = _async_to_generator(function(data) {
            var email;
            return _ts_generator(this, function(_state) {
                switch(_state.label){
                    case 0:
                        email = data.email.trim();
                        return [
                            4,
                            createTestUser({
                                variables: _object_spread_props(_object_spread({}, data), {
                                    email: email
                                })
                            })
                        ];
                    case 1:
                        _state.sent();
                        // A bit of a hack so that we can set mock state if needed before the useIsLoggedIn
                        // navigates us away from this screen
                        setIsLoggingOut(true);
                        return [
                            4,
                            authClient.login(email, data.password)
                        ];
                    case 2:
                        _state.sent();
                        // any data mocking should be done here
                        setIsLoggingOut(false);
                        return [
                            2
                        ];
                }
            });
        });
        return function(data) {
            return _ref.apply(this, arguments);
        };
    }(), function(errors) {
        console.log('errors', errors);
    });
    return /*#__PURE__*/ _jsx(AuthScreenContainer, {
        heading: 'Create test user',
        children: /*#__PURE__*/ _jsxs(View, {
            spacing: 12,
            style: {
                paddingBottom: 100
            },
            children: [
                /*#__PURE__*/ _jsx(Text, {
                    text: "Thank you for testing Aviva. We appreciate your help!",
                    size: 15
                }),
                /*#__PURE__*/ _jsx(Text, {
                    text: "To file a bug report at any time, hold on the screen with three fingers until the Tester menu is shown. Select 'ReportError' and describe your issue in as much detail as possible.",
                    size: 15
                }),
                /*#__PURE__*/ _jsx(Label, {
                    text: "Create new user"
                }),
                error ? /*#__PURE__*/ _jsx(ErrorPresenter, {
                    error: error
                }) : null,
                /*#__PURE__*/ _jsx(Controller, {
                    control: control,
                    render: function(props) {
                        return EmailInputRender(props, {
                            'aria-label': 'Email',
                            ref: emailInputRef,
                            onSubmitEditing: function() {
                                var _passwordInputRef_current;
                                return (_passwordInputRef_current = passwordInputRef.current) === null || _passwordInputRef_current === void 0 ? void 0 : _passwordInputRef_current.focus();
                            }
                        });
                    },
                    name: "email"
                }),
                /*#__PURE__*/ _jsx(Controller, {
                    control: control,
                    render: function(props) {
                        return TextInputRender(props, {
                            secureTextEntry: true,
                            autoComplete: 'new-password',
                            placeholder: 'Password',
                            hint: 'Must be at least 8 characters',
                            ref: passwordInputRef,
                            onSubmitEditing: function(e) {
                                return void request(e);
                            },
                            enterKeyHint: 'next',
                            testID: 'Signup_passwordInput'
                        });
                    },
                    name: "password"
                }),
                APP_SLUG === 'oui-aviva' ? /*#__PURE__*/ _jsx(Controller, {
                    control: control,
                    render: function(props) {
                        return PickerInputRender(props, {
                            label: 'User type',
                            items: [
                                {
                                    label: 'Adult',
                                    value: ProductVariant.AVIVA_ADULT
                                },
                                {
                                    label: 'Adolescent',
                                    value: ProductVariant.AVIVA_ADOLESCENT
                                },
                                {
                                    label: 'Military',
                                    value: ProductVariant.AVIVA_MILITARY
                                },
                                {
                                    label: 'Inpatient',
                                    value: ProductVariant.AVIVA_INPATIENT
                                }
                            ]
                        });
                    },
                    name: "testPatient.productSlug"
                }) : null,
                /*#__PURE__*/ _jsxs(View, {
                    row: true,
                    style: {
                        justifyContent: 'space-between'
                    },
                    children: [
                        /*#__PURE__*/ _jsx(Label, {
                            text: "Control group?"
                        }),
                        /*#__PURE__*/ _jsx(Controller, {
                            control: control,
                            render: function(props) {
                                return SwitchInputRender(props, {
                                    'aria-label': 'Control',
                                    showOnOff: true
                                });
                            },
                            name: "testPatient.productStatic"
                        })
                    ]
                }),
                /*#__PURE__*/ _jsx(Button, {
                    text: "Submit",
                    onPress: request,
                    loading: loading
                })
            ]
        })
    });
}
